export class ValidationFilter {
    public IncludeInactive?: boolean;
}

export default ValidationFilter;